import { createContext } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

export const AlertContext = createContext()




export default function Alerter({ children }) {
    const { t } = useTranslation()


    const alert = (type, text, title, button) => {
        Swal.fire({
            title: title ? title : (type === "error" ? t("alertTitle.error") : t("alertTitle.success")),
            text: text ? text : (type === "error" ? t("alertText.error") : t("alertText.success")),
            icon: type,
            confirmButtonText: button ? button : t("alertButton.ok")
        })
    }

    const showAlert = (type = "success" | "error", text = "", title = "", button = "") => {
        alert(type, text, title, button)
    }

    return (
        <AlertContext.Provider value={{ showAlert }}>
            {children}
        </AlertContext.Provider>
    )
}